import React, { useState } from "react";
import { queryKeys } from "services/querykeys";
import { postRequest, useMutationWrapper, useQueryWrapper } from "services/apiHelper";
import { nanoid } from "nanoid";
import { composersRequest } from "services/request";
import styled from "@emotion/styled";

import ConfirmationModal from "components/BaseModal";
import { Box, Button, FormControl, FormHelperText, FormLabel, Input, Text } from "@chakra-ui/react";
import { successToast, useClickOutside } from "utils/hooks";
import { queryClient } from "App";
interface composerListType {
  name: string;
  id: string;
}

const ComposerModal = ({ isOpen, onClose, newComposer }) => {
  const [composerList, setComposerList] = useState<any>([]);
  const [currentSearch, setCurrentSearch] = useState<string>("");
  const [showDropDown, setshowDropDown] = useState(false);

  const { data: allComposers } = useQueryWrapper(queryKeys.COMPOSERS, composersRequest.COMPOSER, {
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });
  const composersData = allComposers?.data;
  const domNode = useClickOutside(() => {
    setshowDropDown(false);
  });
  const handleSelect = (composer: composerListType) => {
    setshowDropDown(false);
    setCurrentSearch(composer.name);
  };

  const inputChanged = (e) => {
    const searchedText = e.target.value;

    setCurrentSearch(searchedText);
    if (!searchedText) {
      setshowDropDown(false);
      setComposerList([]);
      return;
    }
    const filteredComposer = composersData.filter((composer) =>
      composer.name.toLowerCase().includes(searchedText.toLowerCase()),
    );
    if (filteredComposer.length > 0) {
      setComposerList(filteredComposer);
      setshowDropDown(true);
    } else {
      setshowDropDown(false);
    }
  };
  const [composerName, setComposerName] = useState("");
  const onSuccess = () => {
    void queryClient.invalidateQueries({ queryKey: [queryKeys.COMPOSERS] });

    successToast("New composer has been created");
    onClose();
  };
  const { mutate, isLoading } = useMutationWrapper(postRequest, onSuccess);
  const handleSubmit = (e) => {
    e.preventDefault();
    mutate({
      url: composersRequest.COMPOSER,
      data: {
        name: composerName,
        nickname: composerName,
      },
    });
  };

  return (
    <ConfirmationModal title="Add Composer" isOpen={isOpen} onClose={onClose}>
      <Box>
        <Box>
          <Text display="inline">Current Composer:</Text>
          <Text fontWeight="bold" display="inline">
            {newComposer}
          </Text>
        </Box>
        <Box mt="4">
          <FormControl id="composerName" isRequired mb={4}>
            <FormLabel>Composer</FormLabel>
            <ComposerListWrapper>
              <Input
                type="search"
                onChange={inputChanged}
                placeholder="Search Composer"
                autoComplete="off"
                value={currentSearch}
              />
              <div className={`customer-list ${showDropDown ? "active" : ""}`} ref={domNode}>
                {composerList.length > 0
                  ? composerList.map((composer: any) => (
                      <button
                        type="button"
                        key={nanoid()}
                        onClick={() => {
                          handleSelect(composer);
                        }}
                      >
                        {composer.name}
                      </button>
                    ))
                  : null}
              </div>
            </ComposerListWrapper>
            <FormHelperText m={0}>You can select unknown</FormHelperText>
          </FormControl>
        </Box>
        <Box>
          <Text>Composer Name</Text>
          <Input
            placeholder="composer name"
            onChange={(e) => {
              setComposerName(e.target.value);
            }}
          />
        </Box>
        <Box mt="4">
          <Button onClick={handleSubmit} isLoading={isLoading}>
            Submit
          </Button>
          <Button onClick={onClose} variant="secondary" ml="4">
            Cancel
          </Button>
        </Box>
      </Box>
    </ConfirmationModal>
  );
};

const ComposerListWrapper = styled.div`
  position: relative;
  .customer-list {
    display: none;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 10rem;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    overflow-x: auto;
    h6 {
      padding: 12px 16px;
    }
    button {
      all: unset;
      display: block;
      padding: 12px 16px;
      width: 90%;
      text-transform: capitalize;
      :hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
    .nothing {
      /* background-color:red; */
      width: 100%;
      /* height:100%; */
      img {
        height: 100%;
        max-height: 110px;
      }
    }
  }
  .active {
    display: block;
  }
`;

export default ComposerModal;
